module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/300_1-c0bc77c17ea421e907129338c85f4a5a.jpg";